module.exports = __webpack_public_path__ + "img/m13.cbc30288.jpg";